import React, { useEffect, useRef, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import { Toast } from 'primereact/toast';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './newsTable.scss'
import { faChevronRight, faDatabase, faNewspaper } from '@fortawesome/pro-solid-svg-icons'
import Search from '../../search/search';
import styles from './newsTable.scss';
import moment from 'moment';
import { faPaperclip } from '@fortawesome/pro-light-svg-icons';
import Attachment from './attachment';
import { Modal } from 'react-bootstrap';
import { createRoot } from 'react-dom/client';
import { Skeleton } from 'primereact/skeleton';
import { InputText } from 'primereact/inputtext';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { useTranslation } from 'react-i18next';

const NewsTable = (props) => {
    const { t } = useTranslation();
    const [tableData, setTableData] = useState([]);
    const [columns, setColumns] = useState([]);
    const [visibleSearch, setVisibleSearch] = useState(false);
    const [showPaginator, setShowPaginator] = useState(false);
    const [rowLength, setRowLength] = useState();
    const [visibleAbsoluteSearch, setVisibleAbsoluteSearch] = useState(false);
    const toast = useRef(null);
    const [visible, setVisible] = useState(false);
    const [selectedNews, setSelectedNews] = useState();
    const dataTableRef = useRef(null);
    const scrollBodyRef = useRef(null);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const [isSearchActive, setIsSearchActive] = useState(false);
    // iframe body yüksekliği ve yüklenme durumu için state
    const [iframeBodyHeight, setIframeBodyHeight] = useState(600);
    const [isLoading, setIsLoading] = useState(false);
    const onScrollBottomRef = useRef(null);
    const scrollThrottleRef = useRef(false);

    // Keep the callback ref updated
    useEffect(() => {
        onScrollBottomRef.current = props.onScrollBottom;
    }, [props.onScrollBottom]);

    
    useEffect(() => {
        // Wait for component to render completely
        const timer = setTimeout(() => {
            const scrollBodyElement = document.querySelector('#newsTableBody .p-datatable-wrapper');
            
            console.log('[NewsComponent] NewsTable: Setting up scroll listener...', scrollBodyElement);

            if (scrollBodyElement) {
                scrollBodyRef.current = scrollBodyElement;
                scrollBodyElement.addEventListener('scroll', handleScroll);
                console.log('[NewsComponent] NewsTable: Scroll listener added successfully');
            } else {
                console.warn('[NewsComponent] NewsTable: Could not find scroll element with selector "#newsTableBody .p-datatable-wrapper"');
            }
        }, 500);

        return () => {
            clearTimeout(timer);
            if (scrollBodyRef.current) {
                console.log('[NewsComponent] NewsTable: Removing scroll listener');
                scrollBodyRef.current.removeEventListener('scroll', handleScroll);
                scrollBodyRef.current = null;
            }
        };
    }, []);


    // selectedNews değiştiğinde, iframe body yüksekliğini hesapla
    useEffect(() => {
        if (selectedNews) {
            setIsLoading(true);
            setVisible(true);
        }
    }, [selectedNews]);

    useEffect(() => {
        // setColumns(columnsData);
        if (props.tableData && props.tableData.length > 0) {
            setTableData(props.tableData);

            props.tableData.map((data, i) => {
                if (data.stocks && data.stocks.length > 0) {
                    data.code = data.stocks[0];
                }

                // Ensure description field is searchable
                if (data.description) {
                    data.searchDescription = data.description.toLowerCase();
                }

                // Format date for better search
                if (data.date) {
                    data.searchDate = moment(data.date, "YYYY-MM-DDTHH:mm").format("DD/MM/YYYY HH:mm").toLowerCase();
                }
            });
        }

        if (props.columns && props.columns.length > 0) {
            setColumns(props.columns);
        }
        if (props.visibleSearch !== undefined) {
            setVisibleSearch(props.visibleSearch);
        }
        if (props.paginator !== undefined) {
            setShowPaginator(props.paginator);
        }
        if (props.rowLength !== undefined) {
            setRowLength(props.rowLength);
        }
        if (!props.tableData || props.tableData.length === 0) {
            setTableData([]);
        }
    }, [props]);




    //#region BODY TEMPLATES

    const sourceBodyTemplate = (data, template) => {
        return (
            <div className='source-bg'>
                {data.source === undefined ? 'KAP' : data.source}
            </div>
        )
    };

    const tickerCodeBodyTemplate = (data, template) => {

        return (
            <div className='tickerCode-bg'>
                {uniqueCodeFormat(data.stocks)}
                <FontAwesomeIcon className='p-l-10' icon={faChevronRight} />
            </div>
        )
    };

    const contentBodyTemplate = (data, template) => {
        return (
            <Container className='newsBody' key={data.description}>
                <Row>
                    <Col className=''>
                        <div className='newsTitle roboto-medium-16'>
                            {data.description}
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col className='p-t-10'>
                        <div className='roboto-regular-12 news-date-time'>
                            {dateFormat(data.date)}
                        </div>
                    </Col>
                </Row>
            </Container>
        )
    };


    const attachmentTemplate = (data, template) => {
        // Tıklama olayını kendi içinde izole et
        return (
            <div onClick={(e) => e.stopPropagation()}>
                {attachmentFormat(data.attachments)}
            </div>
        );
    };

    const attachmentFormat = (attachments) => {
        if (attachments.length > 0) {
            // return <FontAwesomeIcon className='' icon={faPaperclip} />
            return <Attachment attachments={attachments} />
        }

        return '';
    }

    const uniqueCodeFormat = (stocks) => {
        let code = '';
        stocks.map((stock, i) => {
            if (i === 0) {
                code = stock;
            }
        })
        return code;
    }

    const dateFormat = (date) => {
        return moment(date, "YYYY-MM-DDTHH:mm").format("DD/MM/YYYY HH:mm");
    }

    const detailFormat = (detail) => {
        if (detail === undefined)
            return;

        let formattedDetail = detail.replace('<!--?xml version="1.0" encoding="ISO-8859-9" ?--><!-- general_role_210015 -->', '');

        // Tema sınıfını kontrol et
        const isDarkTheme = document.body.classList.contains('theme-dark');

        // Iframe içeriği için HTML şablonu oluştur
        const iframeContent = `
            <!DOCTYPE html>
            <html>
            <head>
                <meta charset="UTF-8">
                <meta name="viewport" content="width=device-width, initial-scale=1.0">
                <style>
                    body {
                        margin: 0;
                        padding: 10px 20px;
                        font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
                        ${isDarkTheme ? 'background-color: #2c2c2c; color: #fff;' : 'background-color: #fff; color: #231f20;'}
                    }
                    
                    /* KAP içeriği için stil geliştirmeleri */
                    table {
                        width: 100%;
                        border-collapse: collapse;
                        margin: 15px 0;
                        ${isDarkTheme ? 'border-color: #626262;' : 'border-color: #e4e4e4;'}
                    }
                    
                    td, th {
                        padding: 8px;
                        ${isDarkTheme ? 'color: #fff; border-color: #626262;' : 'color: #231f20; border-color: #e4e4e4;'}
                    }
                    
                    /* Daha büyük font boyutları */
                    div, p, span, td, th {
                        font-size: 14px !important;
                        ${isDarkTheme ? 'color: #fff;' : 'color: #231f20;'}
                    }
                    
                    .font12, .font14, .font16 {
                        font-size: 16px !important;
                    }
                    
                    /* Tabloları daha okunaklı hale getir */
                    .table-bordered {
                        max-width: 100% !important;
                        ${isDarkTheme ? 'border-color: #626262;' : 'border-color: #e4e4e4;'}
                    }
                    
                    /* Genel stil iyileştirmeleri */
                    .bgGreen {
                        ${isDarkTheme ? 'background-color: #306959 !important;' : 'background-color: #409399 !important;'}
                        padding: 10px !important;
                    }
                    
                    .txtWhite {
                        color: white !important;
                    }
                    
                    /* Dark tema için ekstra stiller */
                    ${isDarkTheme ? `
                        a { color: #2fbc99; }
                        a:hover { color: #40776F; }
                        hr { border-color: #626262; }
                        .table-striped tr:nth-child(odd) { background-color: #252728; }
                        .table-striped tr:nth-child(even) { background-color: #2c2c2c; }
                        .table-bordered { border: 1px solid #626262; }
                        .table-bordered td, .table-bordered th { border: 1px solid #626262; }
                    ` : ''}
                </style>
            </head>
            <body>${formattedDetail}</body>
            </html>
        `;

        // iframe elementi al
        const iframe = document.getElementById('news-iframe');

        // İframe'in contentWindow'una erişip içeriği yaz
        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
        iframeDoc.open();
        iframeDoc.write(iframeContent);
        iframeDoc.close();

        // Iframe'in yüksekliğini içerik yüklendikten sonra ayarla
        iframe.onload = () => {
            try {
                // Modal içeriği için daha fazla alan sağla
                const height = iframeDoc.body.scrollHeight + 50; // Biraz ek alan ekle
                // iframe.style.height = `${Math.max(600, height)}px`; // En az 600px yükseklik

                // İframe body'sine padding ekle
                iframeDoc.body.style.padding = '20px';
            } catch (e) {
                console.error("İframe yüksekliği ayarlanamadı:", e);
                // iframe.style.height = '600px'; // Varsayılan yükseklik
            }
        };
    };


    //#endregion BODY TEMPLATES

    //#region DYANMIC COLUMNS

    const dynamicColumns = columns.map((col, i) => {
        if (col.field === 'source') {
            return <Column key={col.id + col.field} field={col.field} body={sourceBodyTemplate} header={col.header} headerStyle={{ width: '100px' }} style={{ width: '1%' }} className='DataTableColumn transition' />;
        } else if (col.field === 'uniqueCode') {
            return <Column key={col.id + col.field} field={col.field} body={tickerCodeBodyTemplate} header={col.header} headerStyle={{ width: '100px' }} style={{ width: '10%' }} className='DataTableColumn transition' filterField="code" filterMatchMode="contains" />;
        } else if (col.field === 'detail') {
            return <Column key={col.id + col.field} field={col.field} body={contentBodyTemplate} header={col.header} headerStyle={{ width: '100px' }} style={{ width: '65%', textAlign: 'left' }} className='DataTableColumn transition' />;
        } else if (col.field === 'attachment') {
            return <Column key={col.id + col.field} field={col.field} body={attachmentTemplate} header={col.header} headerStyle={{ width: '1%' }} style={{ width: '1%', textAlign: 'center' }} className='DataTableColumn transition' />;
        } else {
            return <Column key={col.id + col.field} field={col.field} header={col.header} headerStyle={{ width: '100px' }} style={{ width: '1%' }} className='DataTableColumn transition' />;
        }
    });

    //#endregion DYANMIC COLUMNS

    const customPaginatorTemplate = {
        first: 'First', // Text for the "First" button
        prev: 'Prev',   // Text for the "Previous" button
        next: 'Next',   // Text for the "Next" button
        last: 'Last',   // Text for the "Last" button
    };

    //#region RENDERERS

    const scroll = () => {
        return props.scrollHeight || '750px';
    }

    const handleScroll = (event) => {
        // Throttle scroll events to prevent excessive calls
        if (scrollThrottleRef.current) return;

        const { scrollTop, scrollHeight, clientHeight } = event.target;
        
        console.log(`[NewsComponent] Scroll event: scrollTop=${scrollTop}, clientHeight=${clientHeight}, scrollHeight=${scrollHeight}, threshold=${scrollHeight - 100}`);

        // Kaydırma çubuğu en altta veya ona yakın ise (100px tolerans ile daha yumuşak yükleme)
        if (scrollTop + clientHeight >= scrollHeight - 100) {
            console.log('[NewsComponent] Bottom reached! Calling onScrollBottom callback...');
            if (onScrollBottomRef.current) {
                scrollThrottleRef.current = true;
                onScrollBottomRef.current(); // Belirtilen fonksiyonu çağır
                
                // Reset throttle after 300ms
                setTimeout(() => {
                    scrollThrottleRef.current = false;
                    console.log('[NewsComponent] Throttle reset');
                }, 300);
            } else {
                console.log('[NewsComponent] onScrollBottomRef.current is null/undefined');
            }
        }
    };

    const onGlobalFilterChange = (event) => {
        const value = event.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
        setIsSearchActive(!!value); // Set search active state based on if value exists
    };

    // Özel boş veri mesajı için bir fonksiyon oluşturalım
    const emptyMessageTemplate = () => {
        return (
            <div className="empty-message-container">
                <FontAwesomeIcon icon={faNewspaper} className="empty-message-icon" />
                <div className="empty-message-text">{getEmptyMessage()}</div>
            </div>
        );
    };

    // Get the appropriate empty message based on whether a search is active
    const getEmptyMessage = () => {
        // If search is active and no results
        if (isSearchActive && tableData.length === 0) {
            return t('noSearchResults');
        }

        // If no search active and tableData is empty, show custom empty message or default
        if (!isSearchActive && tableData.length === 0) {
            return props?.emptyMessage || t('news.noNews');
        }

        // Default fallback
        return t('noDataTable');
    };

    // Add custom table styles with fixed height
    const tableStyle = {
        minWidth: '50rem',
        minHeight: scroll()
    };

    // Helper to generate iframe srcDoc with theme styles
    const getIframeSrcDoc = () => {
        const isDark = document.body.classList.contains('theme-dark');
        return `
                    <!DOCTYPE html>
                    <html>
                    <head>
                        <meta charset="UTF-8">
                        <meta name="viewport" content="width=device-width, initial-scale=1.0">
                        <style>
                            body {
                                margin: 0;
                                padding: 10px;
                                background: ${isDark ? '#2c2c2c' : '#fff'};
                                color: ${isDark ? '#fff' : '#000'} !important;
                            }
                            table, td, th {
                                border-color: ${isDark ? '#626262' : '#e4e4e4'} !important;
                                color: ${isDark ? '#fff' : '#000'} !important;
                            }
                            a { color: ${isDark ? '#2fbc99' : '#0066cc'} !important; }
                            * {
                                background: transparent !important;
                                color: inherit !important;
                            }
                        </style>
                    </head>
                    <body>
                        ${selectedNews?.detail || ''}
                    </body>
                    </html>
                `;
    };

    // iframe yüklenince body yüksekliğini al
    const handleIframeLoad = (e) => {
        try {
            const iframe = e.target;
            const doc = iframe.contentDocument || iframe.contentWindow.document;
            const height = doc.body.scrollHeight;
            setIframeBodyHeight(Math.max(100, height));
        } catch (err) {
            setIframeBodyHeight(600);
        }
        setIsLoading(false);
    };


    return (
        <div className='newsTableJs'>
            <Toast ref={toast} />
            {visibleSearch &&
                <Container className='p-b-5 p-t-10' >
                    <Row >
                        <Col md='3' sm='7'>
                            <div className='search-input'>
                                <span className="p-input-icon-left">
                                    <IconField iconPosition="left">
                                        <InputIcon className="pi pi-search"> </InputIcon>
                                        <InputText placeholder={t('seachSymbolShare')} onChange={(e) => onGlobalFilterChange(e)} />
                                    </IconField>
                                </span>
                            </div>
                        </Col>
                    </Row>
                </Container>
            }

            <DataTable
                ref={dataTableRef}
                id='newsTableBody'
                stateStorage="session"
                value={tableData}
                style={tableStyle}
                tableStyle={{ minWidth: '50rem' }}
                paginator={showPaginator}
                rows={rowLength}
                selectionMode="single"
                selection={selectedNews}
                onSelectionChange={(e) => setSelectedNews(e.value)}
                scrollable
                scrollHeight={scroll()}
                emptyMessage={emptyMessageTemplate}
                filters={filters}
                onFilter={(e) => {
                    setFilters(e.filters);
                    setIsSearchActive(!!e.filters.global?.value);
                }}
                //globalFilterFields={['source', 'code', 'stocks', 'description', 'searchDescription', 'detail', 'date', 'searchDate']}
                globalFilterFields={['source', 'code', 'stocks']}
                filterDelay={300}
                showGridlines
            >
                {dynamicColumns}
            </DataTable>

            <Modal
                show={visible}
                onHide={() => setVisible(false)}
                size="xl"
                fullscreen="lg-down"
                centered
                dialogClassName="news-detail-modal news-detail-modal-large"
                contentClassName="modal-content"
            >
                <Modal.Header closeButton className="modal-header news-modal-header">
                    <Modal.Title className="modal-title">{selectedNews?.description}</Modal.Title>
                </Modal.Header>
                <Modal.Body className="modal-body p-0" style={{ position: 'relative', minHeight: 120 }}>
                    {isLoading && (
                        <div style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            background: 'rgba(255,255,255,0.7)',
                            zIndex: 10,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <span className="spinner-border" role="status" aria-hidden="true"></span>
                        </div>
                    )}
                    <iframe
                        title="News Content"
                        srcDoc={getIframeSrcDoc()}
                        style={{ width: '100%', minHeight: iframeBodyHeight, border: 'none', overflow: 'auto', opacity: isLoading ? 0 : 1, transition: 'opacity 0.2s' }}
                        sandbox="allow-same-origin allow-scripts"
                        onLoad={handleIframeLoad}
                    />
                </Modal.Body>
                <Modal.Footer className="modal-footer news-modal-footer">
                    <button className="btn btn-secondary btn-theme" onClick={() => setVisible(false)}>
                        {t('close') || 'Kapat'}
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    )

    //#endregion RENDERERS
}

export default NewsTable

